import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Hair_2 = ({ hairColours }) => {
  const primary = hairColours.base;
  const secondary = hairColours.shadow;

  return (
    <>
      <g>
        <path
          fill={primary}
          d="M555.1,347.4c-1.4-31-7.5-68.5-26.8-94.1c-2.2-3-4.9-5.9-7.8-8.9c2.4-9.1,6.3-17.4,13.7-22.5
		c4.3-3,10.2-3.7,20.1,0.9c0,0-7.7-26.8-24.5-32c-15.6-4.8-29.2-2-56.9,25.6c-0.4-0.1-0.8-0.2-1.1-0.4c1.3-8,10-41.3,67.2-35
		c0,0-67.1-60.8-108.9,23.9c0,0,0.9-45,53.7-52.5c0,0-72.2-35.6-107,53.6c0,0-7-44.6,60.9-64.9c0,0-53.4-16-104,48.6
		c0,0-2.9-27.7,46.5-51c0,0-136-14.4-117.4,128.2c0,0,0,0.1,0.1,0.2c-12.4,23.8-17,53.3-18.3,78.8c-1.1,22.2,2.9,44.6,13.5,64.1
		c6.8,12.5,9.6,37.4,10.6,52.6c0.5-0.7,1-1.5,1.5-2.2c0.9-1.3,2-1.9,3.2-2.1c-0.2-0.8-0.3-1.6-0.5-2.4c3.1-25.5,4-61.6,4.1-73.3
		c0.1-12.3,19.2-59.2,18.4-81.2c-0.1-3.3,0-6.3,0.2-9.1c1.7,0.3,3.6,0.5,5.5,0.7c8,0.5,16.1,1,23.9,2.6c16,3.2,45.2,10.2,75.1,10.2
		c33.4,0,78.5-12.2,101.7-9.5c0.8,0.1,1.5-0.1,2.3-0.1c0.1,1.8,0.1,3.5,0,5.4c-0.8,22,18.3,68.9,18.4,81.2
		c0.1,12.2,1.1,50.2,4.5,75.8c-0.1,0.4,0.8,1,1.4,1c1.3,0,2.3,0.4,3.1,1.1c0.1-2.4,0.2-4.9,0.3-7.6c1.5-14.7,4.3-32.9,9.9-42.9
		C552,390.9,556,369,555.1,347.4z"
        />
        <path
          fill={secondary}
          d="M297.1,270.2c-8-25.2-0.8-48.3,3.7-62.3c2.7,23.8,14.7,46.3,33,61.8c1.2-17.9,6.3-35.5,14.8-51.3
		c1.9,24.1,12.8,47.4,30.2,64.2c4.3-21.7,13.3-42.4,26.4-60.3c-3.4,18.1-0.9,37.3,7,54c15-14.7,26.7-32.6,34.2-52.2
		c-1.5,17.9-2.9,35.9-4.4,53.8c18.6-15.8,36.8-32,54.8-48.6c3.5,14.8-7.7,34.8-16.2,45.3c26.5-2,35.9-18.7,40.1-30.3
		c2.4-9.1,6.3-17.4,13.7-22.5c4.3-3,10.2-3.7,20.1,0.9c0,0-7.7-26.8-24.5-32c-15.6-4.8-29.2-2-56.9,25.6c-0.4-0.1-0.8-0.2-1.1-0.4
		c1.3-8,10-41.3,67.2-35c0,0-67.1-60.8-108.9,23.9c0,0,0.9-45,53.7-52.5c0,0-72.2-35.6-107,53.6c0,0-7-44.6,60.9-64.9
		c0,0-53.4-16-104,48.6c0,0-2.9-27.7,46.5-51c0,0-77.4-8.1-107.4,49.1c-7.5,13.3-10.5,28.7-11.5,42.4
		C259.7,249.1,297.1,270.2,297.1,270.2z"
        />
      </g>
    </>
  );
};

export default Hair_2;
